module.exports = __webpack_public_path__ + "images/feature/calendar-2-a10912207acd1fa00449d247990e6ad8.jpg";